module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Component-9e3c2711d0f199418c05c0ffb16242c6.svg";